export const BRANDING_VISUAL_STORAGE_KEY = 'provi_branding_visual_config';

export const DEFAULT_BRANDING_VISUAL = {
  logo_main_url: '',
  logo_horizontal_url: '',
  logo_icon_url: '',
  favicon_url: '',
  pwa_icon_192_url: '',
  pwa_icon_512_url: '',
  auth_logo_url: '',
  admin_logo_url: ''
};

const hasBrowserStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

export const readBrandingVisual = () => {
  if (!hasBrowserStorage()) return { ...DEFAULT_BRANDING_VISUAL };

  try {
    const raw = window.localStorage.getItem(BRANDING_VISUAL_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_BRANDING_VISUAL };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_BRANDING_VISUAL, ...(parsed && typeof parsed === 'object' ? parsed : {}) };
  } catch (error) {
    console.warn('No se pudo leer la identidad visual:', error);
    return { ...DEFAULT_BRANDING_VISUAL };
  }
};

export const saveBrandingVisual = (config) => {
  const nextConfig = { ...DEFAULT_BRANDING_VISUAL, ...(config || {}) };

  if (hasBrowserStorage()) {
    window.localStorage.setItem(BRANDING_VISUAL_STORAGE_KEY, JSON.stringify(nextConfig));
  }

  return nextConfig;
};

const ensureIconLink = (rel) => {
  const selector = `link[rel="${rel}"]`;
  let link = document.querySelector(selector);

  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }

  return link;
};

export const applyFavicon = (faviconUrl) => {
  if (typeof document === 'undefined') return;

  const href = (faviconUrl || '').trim() || '/favicon.ico';
  ['icon', 'shortcut icon', 'apple-touch-icon'].forEach((rel) => {
    const link = ensureIconLink(rel);
    link.setAttribute('href', href);
  });
};

export const getBrandingVisualAsset = (key) => {
  return readBrandingVisual()[key] || '';
};
